import angular from 'angular';
import angularUiBootstrap from 'angular-ui-bootstrap';
import {InfoWindowComponent} from './info-window.component';

export default angular.module('slViz.infoWindowModule', [
    angularUiBootstrap
])
    .component('infoWindow', InfoWindowComponent)
    .name;



// WEBPACK FOOTER //
// ./src/js/components/info-window/index.js